import { render, staticRenderFns } from "./BatchOrder.vue?vue&type=template&id=10686e60&scoped=true&"
import script from "./BatchOrder.vue?vue&type=script&lang=js&"
export * from "./BatchOrder.vue?vue&type=script&lang=js&"
import style0 from "./BatchOrder.vue?vue&type=style&index=0&id=10686e60&scoped=true&lang=scss&"
import style1 from "./BatchOrder.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./BatchOrder.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10686e60",
  null
  
)

export default component.exports